export const FETCH_THREAD_LIST = 'fetch_thread_list';
export const FETCH_THREAD_LIST_SUCCESS = 'fetch_thread_list_success';
export const FETCH_THREAD_LIST_ERROR = 'fetch_thread_list_error';



// WEBPACK FOOTER //
// ./src/actions/types.js